import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { useMemo } from 'react'
dayjs.extend(utc)
dayjs.extend(timezone)

type MonthOutput = 'number' | 'name' | 'short' | 'key'

export const useDateOperators = () => {
  const tz = dayjs.tz.guess()
  const userTimezone = useMemo(() => dayjs.tz.guess() || 'America/Detroit', [])
  // Keep this if you like the plain month name
  const extractMonth = (iso: string) => dayjs.tz(iso, tz).format('MMMM') // "July"

  // Unified formatter
  const monthFromISO = (iso: string, opts: { tz?: string; as?: MonthOutput } = {}) => {
    const { tz: targetTz = tz, as = 'number' } = opts
    const d = dayjs.tz(iso, targetTz)

    if (as === 'name') return d.format('MMMM') // "July"
    if (as === 'short') return d.format('MMM') // "Jul"
    if (as === 'key') return d.format('YYYY-MM') // "2025-07"
    return d.month() + 1 // 1-12
  }

  // Convenience helpers
  const monthKeyFromISO = (iso: string, targetTz: string = tz) => dayjs.tz(iso, targetTz).format('YYYY-MM') // "2025-07"

  const currentMonthKey = (targetTz: string = tz) => dayjs().tz(targetTz).format('YYYY-MM') // e.g. "2025-10"
  const monthKey = useMemo(() => currentMonthKey(userTimezone), [userTimezone])
  const byMonth = (timeCreated: string) => timeCreated && monthKeyFromISO(String(timeCreated), tz) === monthKey

  return { extractMonth, monthFromISO, monthKeyFromISO, currentMonthKey, byMonth }
}
